import { render, staticRenderFns } from "./view-logs.vue?vue&type=template&id=64cdf0a7&"
import script from "./view-logs.vue?vue&type=script&lang=js&"
export * from "./view-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports